import styled from 'styled-components';
import MUISkeleton from '@material-ui/core/Skeleton';

export const Container = styled(MUISkeleton).attrs({
  height: 66 as string | number | undefined,
})`
  margin-top: -1rem;
`;
